import { hasAuth } from 'meinian-package/src/utils/auth'

export const TAB_ENUM = { style: 1, shop: 2, blogger: 3, inspiration: 4 }

export const getTabOption = () => {
  const options = [
    { label: '款式', value: TAB_ENUM.style, auth: hasAuth('dl_ins'), },
    { label: '店铺', value: TAB_ENUM.shop, auth: hasAuth('dl_monitor_center') },
    { label: '博主', value: TAB_ENUM.blogger, auth: hasAuth('dl_ins'), },
    { label: '官方灵感集', value: TAB_ENUM.inspiration, auth: true, }
  ]
  return options.filter(i => i.auth)
}

export const getCardTypeOption = (tabValue = 1) => {
  const result = {
    [TAB_ENUM.style]: {
      allowClear: true,
      defaultValue: null,
      option: [
        { label: 'INS', value: 11 },
        { label: '小红书', value: 37 }
      ]
    },
    [TAB_ENUM.shop]: {
      allowClear: false,
      defaultValue: null,
      option: [
        // { label: '淘宝店铺', value: 8 },
      ]
    },
    [TAB_ENUM.blogger]: {
      allowClear: false,
      defaultValue: 11,
      option: [
        { label: 'INS', value: 11 },
        { label: '小红书', value: 37 }
      ]
    },
    [TAB_ENUM.inspiration]: {
      allowClear: false,
      defaultValue: 'all',
      option: [
        { label: '全部', value: 'all' },
        { label: '女装', value: 'women' },
        { label: '男装', value: 'men' },
        { label: '童装', value: 'child' },
        { label: '鞋靴', value: 'shoes' }
      ]
    },
  }
  return result[tabValue] || { option: [] }
}
